const toBoolean = (value) => value === true;

const toString = (value) =>
  typeof value === "string" ? value : "";

export function normalizePermissions(permissions = {}) {
  return {
    canReAssignUser: toBoolean(permissions.can_re_assign_user),
    canEditUser: toBoolean(permissions.can_edit_user),
    canBlockUser: toBoolean(permissions.can_block_user),
    canAddUser: toBoolean(permissions.can_add_user),

    canSendB2BRelationshipRequest: toBoolean(
      permissions.can_send_b2b_relationship_request
    ),

    canAcceptRejectB2BRelationshipRequest: toBoolean(
      permissions.can_accept_reject_b2b_relationship_request
    ),

    canManageContracts: toBoolean(permissions.can_manage_contracts),

    canDeAssociateB2BRelationship: toBoolean(
      permissions.can_de_associate_b2b_relationship
    ),

    canAddRemoveOrganizationfromExcludelist: toBoolean(
      permissions.can_add_remove_organizationfrom_excludelist
    ),

    canCreateWorkkard: toBoolean(permissions.can_create_workkard),
    canChangeWorkkardSponsor: toBoolean(
      permissions.can_change_workkard_sponsor
    ),
    canArchiveWorkkard: toBoolean(permissions.can_archive_workkard),

    canCreateActivity: toBoolean(permissions.can_create_activity),
    canReassignActivity: toBoolean(permissions.can_reassign_activity),

    canAcceptRejectActivity: toBoolean(
      permissions.can_accept_reject_activity
    ),

    canArchiveActivity: toBoolean(permissions.can_archive_activity),
    canCloseActivity: toBoolean(permissions.can_close_activity),

    canAcceptRejectBid: toBoolean(
      permissions.can_accept_reject_bid
    ),

    canReceiveUnAssignedActivities: toBoolean(
      permissions.can_receive_un_assigned_activities
    ),

    canReopenActivity: toBoolean(permissions.can_reopen_activity),

    canChangeActivityOwner: toBoolean(
      permissions.can_change_activity
    ),

    canMarkActivityAsInProgress: toBoolean(
      permissions.can_mark_activity_as_in_progress
    ),

    canCompleteActivity: toBoolean(
      permissions.can_complete_activity
    ),

    canCloseActivityduringMidterm: toBoolean(
      permissions.can_close_activity_during_mid_term
    ),

    canAddPersonalNotes: toBoolean(
      permissions.can_add_personal_notes
    ),

    canAddPrivateNotes: toBoolean(
      permissions.can_add_private_notes
    ),

    canAddPublicNotes: toBoolean(
      permissions.can_add_public_notes
    ),

    canDeleteUpdateNotesWithinConfiguredTimeFrame: toBoolean(
      permissions.can_delete_update_notes_within_configured_time_frame
    ),

    canCreateDailyActivityAssignmentRules: toBoolean(
      permissions.can_create_daily_activity_assignment_rules
    ),

    canCreateBidActivityAssignmentRules: toBoolean(
      permissions.can_create_bid_activity_assignment_rules
    ),

    canCreateCATActivityAssignmentRules: toBoolean(
      permissions.can_create_cat_activity_assignment_rules
    ),

    canCreateCATBidActivityAssignmentRules: toBoolean(
      permissions.can_create_cat_bid_activity_assignment_rules
    ),

    canManageSettings: toBoolean(permissions.can_manage_settings),

    canManageCompanyProfile: toBoolean(
      permissions.can_manage_company_profile
    ),

    canReceiveUnAssignedWorkkards: toBoolean(
      permissions.can_receive_un_assigned_workkards
    ),

    canResetPassword: toBoolean(permissions.can_reset_password),
    canViewDeletedTodo: toBoolean(permissions.can_view_deleted_todo),

    canCreateTodo: toBoolean(permissions.can_create_todo),
    canEditTodo: toBoolean(permissions.can_edit_todo),
    canEditOwnTodo: toBoolean(permissions.can_edit_own_todo),
    canDeleteTodo: toBoolean(permissions.can_delete_todo),

    canAddWatchers: toBoolean(permissions.can_add_watchers),

    canActAsHiddenWatcher: toBoolean(
      permissions.can_act_as_hidden_watcher
    ),

    canViewWorkload: toBoolean(permissions.can_view_workload),

    canViewB2BWorkload: toBoolean(
      permissions.can_view_b2b_workload
    ),

    canAssignB2B: toBoolean(permissions.can_assign_b2b),

    canAddMatrixReport: toBoolean(
      permissions.can_add_matrix_report
    ),

    inviteUserToAccessCommunity: toBoolean(
      permissions.invite_user_to_access_community
    ),

    canAddCustomFields: toBoolean(
      permissions.can_add_custom_fields
    ),

    canAddNoteTemplates: toBoolean(
      permissions.can_add_note_templates
    ),

    canCloneNotes: toBoolean(permissions.can_clone_notes),
    canManageRules: toBoolean(permissions.can_manage_rules),

    canCloseActivityInViews: toBoolean(
      permissions.can_close_activity_in_views
    ),

    canCompleteDiaryInViews: toBoolean(
      permissions.can_complete_diary_in_views
    ),

    canCompleteOrReopenDiary: toBoolean(
      permissions.can_complete_or_reopen_diary
    ),

    canAddPublicNotesWorkkard: toBoolean(
      permissions.can_add_public_notes_workkard
    ),

    canAddInternalNotesWorkkard: toBoolean(
      permissions.can_add_internal_notes_workkard
    ),

    canAddPersonalNotesWorkkard: toBoolean(
      permissions.can_add_personal_notes_workkard
    ),

    canAddPublicNotesActivity: toBoolean(
      permissions.can_add_public_notes_activity
    ),

    canAddInternalNotesActivity: toBoolean(
      permissions.can_add_private_notes_activity
    ),

    canAddPersonalNotesActivity: toBoolean(
      permissions.can_add_personal_notes_activity
    ),

    canCreateParty: toBoolean(permissions.can_create_party),
    canDeleteParty: toBoolean(permissions.can_delete_party),
    canConnectMailbot: toBoolean(permissions.can_connect_mailbot),

    canAccessFinancials: toBoolean(
      permissions.can_access_financials
    ),

    canAccessInbox: toBoolean(permissions.can_access_inbox),
    canManageInbox: toBoolean(permissions.can_manage_inbox),
    canCloseWorkkard: toBoolean(permissions.can_close_workkard),
    canAccessAccounts: toBoolean(permissions.can_access_accounts),

    authorizedStates: toString(permissions.authorized_states),

    financialPermissions: toString(
      permissions.financial_permissions
    ),

    inboxPermissions: toString(permissions.inbox_permissions),

    canAccessLetters: toBoolean(permissions.can_access_letters),

    canRequestForLetter: toBoolean(
      permissions.can_request_for_letter
    ),

    canShareProposal: toBoolean(permissions.can_share_proposal),

    canAccessMercury: toBoolean(permissions.can_access_mercury),

    mercuryPermissions: toString(
      permissions.mercury_permissions
    ),

    canManageAtlas: toBoolean(permissions.can_manage_atlas),

    canApplyAggregationInViews: toBoolean(
      permissions.can_apply_aggregation_in_views
    ),

    letterWebPermissions: toString(
      permissions.letter_web_permissions
    ),

    letterAdminPermissions: toString(
      permissions.letter_admin_permissions
    ),

    canManageCommunication: toBoolean(
      permissions.can_manage_communication
    ),

    canAccessBulkInbox: toBoolean(
      permissions.can_access_bulk_inbox
    ),

    canEditWorkkard: toBoolean(permissions.can_edit_workkard),

    canEditClosedWorkkard: toBoolean(
      permissions.can_edit_closed_workkard
    ),

    canEditActivity: toBoolean(permissions.can_edit_activity),

    canReopenWorkkard: toBoolean(
      permissions.can_reopen_workkard
    ),

    canAccessReviewSystem: toBoolean(
      permissions.can_access_review_system
    ),

    reviewSystemPermissions: toString(
      permissions.review_system_permissions
    ),
  };
}